import { createSlice } from "@reduxjs/toolkit";
 
const initialState = {
  Head: { 
      "A_Transid":0,
      "A_Date":new Date(),
      "A_Location":"",
      "Loc_Name":"",
      "A_Narration":"",
      "A_Status":"ENTER",
      "CreatedBy":"",
      "CreatedDate":"", 
      "ApproveStatus": "ENTER",
      "ApprovedBy": '',
      "ApproveDt": ''  
  },
};

const SliceStockSetupChangeRequest = createSlice({
  name: "SliceStockSetupChangeRequest",
  initialState: { value: initialState },

  reducers: {
    Head_Set: (state, action) => {
      state.value.Head = action.payload;
    },
    StockSetupChangeRequest_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const { Head_Set , StockSetupChangeRequest_Init } =  SliceStockSetupChangeRequest.actions;
export default SliceStockSetupChangeRequest.reducer;
